


































import _ from 'lodash';
import { editFactory, mapActionsDvm, mapMutationsDvm } from '@/main/pages';

import UdajeOFirme from './tabs/UdajeOFirme.vue';
import FirmaNastaveni1 from './tabs/FirmaNastaveni1.vue';
import FirmaNastaveni2 from './tabs/FirmaNastaveni2.vue';
import AplikaceNastaveni from './tabs/AplikaceNastaveni.vue';
import GrafLoga from './tabs/GrafLoga.vue';
import ServisniPersonal from './tabs/ServisniPersonal.vue';
import FleetCentrum from './tabs/FleetCentrum.vue';
import CertSpecOprav from './tabs/CertSpecOprav.vue';
import Planner from './tabs/PlannerSetting.vue';
import { NAME, TAB_NAMES, TABS } from './constants';
import { store } from './store/edit';
import { apiProvider } from './api';

export default editFactory(NAME, store).extend({
	components: {
		UdajeOFirme,
		FirmaNastaveni1,
		FirmaNastaveni2,
		AplikaceNastaveni,
		GrafLoga,
		ServisniPersonal,
		FleetCentrum,
		CertSpecOprav,
		Planner,
	},
	data() {
		return {
			tabNames: TAB_NAMES,
		};
	},
	computed: {
		tabItems() {
			const tabItems = [];

			if (this.hasTabAccess(NAME, TABS.UdajeOFirme)) tabItems.push(TAB_NAMES.UDAJE_O_FIRME);
			if (this.hasTabAccess(NAME, TABS.Fn1)) tabItems.push(TAB_NAMES.FIRMA_NASTAVENI_1);
			if (this.hasTabAccess(NAME, TABS.Fn2)) tabItems.push(TAB_NAMES.FIRMA_NASTAVENI_2);
			if (this.hasTabAccess(NAME, TABS.AplikaceNastaveni)) tabItems.push(TAB_NAMES.APLIKACE_NASTAVENI);
			if (this.hasTabAccess(NAME, TABS.GrafLoga)) tabItems.push(TAB_NAMES.GRAF_LOGA);
			if (!this.isCreateMode && this.hasTabAccess(NAME, TABS.ServPersProvoz)) tabItems.push(TAB_NAMES.SERVISNI_PERSONAL);
			if (!this.isCreateMode && this.hasTabAccess(NAME, TABS.SpecialistaNehody)) tabItems.push(TAB_NAMES.CERT_SPEC_OPRAV);
			if (!this.isCreateMode && this.hasTabAccess(NAME, TABS.FleetCentrum)) tabItems.push(TAB_NAMES.FLEET_CENTRUM);
            if (this.hasTabAccess(NAME, TABS.Planner)) tabItems.push(TAB_NAMES.PLANNER);

			return _.pick(TABS, tabItems);
		},
	},
	methods: {
		...mapMutationsDvm(store.mutations),
		...mapActionsDvm(store.actions),
		async loadData(): Promise<void> {
			this.loadTextLong();
			if (this.isCreateMode) {
				await this.default();
			} else {
				await this.entity();
			}
		},
		async loadTextLong() {
			this.startLoading();
			this.headers.fleetCentrum = await this.LocalizeTextLong('fleetCentrumHeader');
			this.headers.certSpecOprav = await this.LocalizeTextLong('certSpecOpravHeader');
			this.endLoading();
		},
		async additionalTabClick(tab: any): Promise<void> {
			await this.getProvozovnaTableSchemaAndRows(tab.$props.name);
		},
		refreshFun() {
			return this.getProvozovnaTableSchemaAndRows(TAB_NAMES.SERVISNI_PERSONAL);
		},
		async saveClick() {
			if(this.edit.PlannerStartTime == null || this.edit.PlannerEndTime == null)
			{
			   this.showErrorAlert({ message: this.LocalizePopisPoli('PLANNER_START_AND_END_TIME') });
			}
			else if(this.edit.LunchStartTime == null || this.edit.LunchEndTime == null)
			{
				this.showErrorAlert({ message: this.LocalizePopisPoli('LUNCH_START_AND_END_TIME') });
			}
			else {
				const res = await this.save(false);
				const workshopId = sessionStorage.getItem('workshopId');
				const params = {
					workshopId,
				};
				const dealerLocationResult = await apiProvider.DealerWorkShopDetails(params);
				localStorage.setItem('DealerWorkShopDetails', JSON.stringify(dealerLocationResult?.data));
			}
		},

	},
});
